export const casinoCurrencyList = {
"DIGITAINSPORTSBOOK" : {currencyEquals: "1"},
"DIGITAINESPORTS" : {currencyEquals: "1"},
"VSPORTS" : {currencyEquals: "100"},
"LOTUS" : {currencyEquals: "1"},
"SUPERNOVA" : {currencyEquals: "1"},
"EVOLUTION" : {currencyEquals: "1"},
"DRCCASINO" : {currencyEquals: "100"},
"DRCCASINO2" : {currencyEquals: "1"},
"VIVO" : {currencyEquals: "1"},
"WAC" : {currencyEquals: "1"},
"PRAGMATIC" : {currencyEquals: "1"},
"BETGAMES" : {currencyEquals: "1"},
"DRCROYAL" : {currencyEquals: "1"},
"DRCHUD" : {currencyEquals: "1"},
"LUDOCRICKET" : {currencyEquals: "1"},
"SPRIBE" : {currencyEquals: "100"},
"MAC88_LD" : {currencyEquals: "1"},
"STUDIO21" : {currencyEquals: "1"},
"EVOLUTIONMAC88" : {currencyEquals: "1"},
"INOUT" : {currencyEquals: "1"},
"UNIVERSESTUDIO" : {currencyEquals: "1"},
"RVGAMES" : {currencyEquals: "1"},
"EZUGIMAC88" : {currencyEquals: "1"},
};